module.exports = __webpack_public_path__ + "img/202509-2_09.ce27c92a.jpg";